__turbopack_context__.v({
  "mdTable": "14-to-24-page-module__ufnDwa__mdTable",
  "page": "14-to-24-page-module__ufnDwa__page",
});
